export const devopsRoutes = {
  environments: "/devops/environments",
  environmentNew: "/devops/environments/new",
  environmentView: (uuid: string) => `/devops/environments/${uuid}`,
  environmentEdit: (uuid: string) => `/devops/environments/${uuid}/edit`,
  applications: "/devops/applications",
  applicationNew: "/devops/applications/new",
  applicationView: (uuid: string) => `/devops/applications/${uuid}`,
  applicationEdit: (uuid: string) => `/devops/applications/${uuid}/edit`,
  configurations: "/devops/configurations",
  configurationNew: "/devops/configurations/new",
  configurationView: (uuid: string) => `/devops/configurations/${uuid}`,
  configurationEdit: (uuid: string) => `/devops/configurations/${uuid}/edit`,
  releases: "/devops/releases",
  releaseNew: "/devops/releases/new",
  releaseView: (uuid: string) => `/devops/releases/${uuid}`,
  releaseEdit: (uuid: string) => `/devops/releases/${uuid}/edit`,
} as const;

export type DevopsRecordMode = "view" | "edit" | "create";
